module.exports = __webpack_public_path__ + "img/58.e297d239.jpg";